var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cp",class:{ 'cp-acento': _vm.acento }},[_c('div',{staticClass:"cp-h"},[_c('h2',[_vm._v(_vm._s(_vm.titulo))]),_vm._v(" "),(_vm.pista)?_c('span',{staticClass:"cp-hint"},[_vm._v(_vm._s(_vm.pista))]):_vm._e(),_vm._v(" "),_vm._t("accion")],2),_vm._v(" "),_c('div',{staticClass:"cp-b"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }